<template>
    <div class="p-root root">
        <OStatisticsController/>
        <OExceptionsHandler/>
        <router-view />
        <div
            v-if="isRedirected"
            class="root__wrapper"
        >
            <AButton
                v-for="(route, index) in routes"
                :key="index"
                :text="route.name"
                @onClick="redirect(route.path)"
            />
        </div>
    </div>
</template>

<script>
import AButton from '../../atoms/a-button/a-button';
import * as Sentry from '@sentry/browser';
import {mapActions} from "vuex";
import OStatisticsController from "../../organisms/o-statistics-controller/o-statistics-controller";
import OExceptionsHandler from "../../organisms/o-exceptions-handler/o-exceptions-handler";

export default {
    name: 'PRoot',
    data() {
        return {
            redirected: false,
            routes: [
                {
                    name: 'Terminal',
                    path:'/terminal-XPM-D4FO-1L4X-PF82/start?fitscreen=1',
                },
                {
                    name: 'Desktop/Mobile',
                    path:'/map-79962313/'
                },
            ]
        }
    },
    components: {
        OExceptionsHandler,
        OStatisticsController,
        AButton
    },
    computed: {
        isRedirected() {
            return this.$route.path === '/';
        }
    },
    methods: {
        ...mapActions([
            "registerAWSIdentity",
            "generateSessionId",
        ]),
        redirect(val) {
            this.$router.push(
                {
                    path: val
                }
            );
        }
    },
    created() {
        if(!document.location.href.includes('localhost')){
            Sentry.setTag("app-type", this.$route.name && this.$route.name.split('.')[0]);
        }

        this.registerAWSIdentity();
        this.generateSessionId();
    }
}
</script>

<style lang="scss">
@import "p-root";
</style>
